module.exports = __webpack_public_path__ + "img/ercode_img.d4563cf6.png";